import o from "./_baseGetTag.js";
import a from "./isObject.js";
var e = o, r = a, c = "[object AsyncFunction]", i = "[object Function]", s = "[object GeneratorFunction]", u = "[object Proxy]";
function b(n) {
  if (!r(n))
    return !1;
  var t = e(n);
  return t == i || t == s || t == c || t == u;
}
var j = b;
export {
  j as default
};
//# sourceMappingURL=isFunction.js.map
